module.exports = __webpack_public_path__ + "static/img/img_logo.f13ce9a0.png";